import { render } from "./TheInvoicesDocuments.vue?vue&type=template&id=7d997f90"
import script from "./TheInvoicesDocuments.vue?vue&type=script&lang=js"
export * from "./TheInvoicesDocuments.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__